import { request } from "utils/request";
import { AxiosPromise } from "axios";
import { ChecklistRefType } from "types/checklist";

export const checklistApi = {
  findAll: (params: { refType: ChecklistRefType; refId: number }): AxiosPromise<any> =>
    request({
      url: "/v1/admin/checklist",
      params,
    }),
  create: (data: {
    refType: ChecklistRefType;
    refId: number;
    name: string;
    deadlineAt?: number;
    done?: boolean;
  }): AxiosPromise<any> =>
    request({
      url: "/v1/admin/checklist",
      data,
      method: "post",
    }),
  update: (id: number, data: { name?: string; deadlineAt?: number; done?: boolean }): AxiosPromise<any> =>
    request({
      url: `/v1/admin/checklist/${id}`,
      method: "patch",
      data,
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/checklist/${id}`,
      method: "delete",
    }),
};
